<div class="row">
  <div class="col-12">
    @if (infoMessage) {
    <div class="container-style mb-1" id="info-message-container">
      <i class="pi pi-info-circle me-1" style="font-size: 0.8rem;"></i>
      <span class="fw-bold">{{ infoMessage }}</span>
    </div>
    }
    <section class="container-style">
      <div class="col-12">
        <app-custom-table [showRecover]="true" [showExport]="true" [headers]="headers" [data]="data"
          (onPageChange)="onPageChangeEmit($event)" (onExport)="onExportEmit()">
        </app-custom-table>
      </div>
      @if (buttonLabel) {
      <div class="col-12 d-flex justify-content-end mt-3">
        <app-custom-button id="close-button" [title]="buttonLabel" [width]="'7rem'" [label]="buttonLabel"
          [severity]="'contrast'" (onClick)="close()">
        </app-custom-button>
      </div>
      }
    </section>
  </div>
</div>